import { render, staticRenderFns } from "./DeviceLayout.vue?vue&type=template&id=ed2d777c&scoped=true"
import script from "./DeviceLayout.vue?vue&type=script&lang=js"
export * from "./DeviceLayout.vue?vue&type=script&lang=js"
import style0 from "./DeviceLayout.vue?vue&type=style&index=0&id=ed2d777c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2d777c",
  null
  
)

export default component.exports